const $placeOrderError = $("#place-order-popup-error");
const $placeOrderModalPopup = $("#error-popup-place-order-modal");

/**
 * Displays the error message received from Place Order in a popup 
 */
const showPlaceOrderPopupError = () => {
    if (!$placeOrderError.length || !$placeOrderModalPopup.length || !($placeOrderModalPopup && $placeOrderModalPopup.find(".modal-body").length)) { 
        return; 
    }

    if ($placeOrderError.data("popup-error")) {
        $placeOrderModalPopup.modal("show");
    }
};

export { showPlaceOrderPopupError };
